const snap = {
    property: [
        { text: 'Name', value: 'name' },
        { text: 'Status', value: 'autostart' },
        { text: 'Installed', value: 'installed' }
    ],
    list: [{
            name: 'app-jujue',
            src: require('@/assets/images/apps/jujue_512x512.png')
        },
        {
            name: 'ultra-app',
            src: require('@/assets/images/apps/ultra_512x512.png')
        },
        {
            name: 'fbots',
            src: require('@/assets/images/apps/fbot_512x512.png')
        },
        {
            name: 'fbuilder',
            src: require('@/assets//images/apps/fbuilder_512x512.png')
        },
        {
            name: 'flowbot',
            src: require('@/assets//images/apps/fbot_512x512.png')
        },
        {
            name: 'gdesk',
            src: require('@/assets/images/apps/keybot_512x512.png')
        },
        {
            name: 'jboard',
            src: require('@/assets/images/apps/jboard_512x512.png')
        },
        {
            name: 'keybot',
            src: require('@/assets/images/apps/keybot_512x512.png')
        },
        {
            name: 'logmms',
            src: require('@/assets/images/apps/logmms_512x512.png')
        },
        {
            name: 'mote',
            src: require('@/assets/images/apps/mote_512x512.png')
        },
        {
            name: 'smartscreen',
            src: require('@/assets/images/apps/smartscreen_512x512.png')
        },
        {
            name: 'sscreen',
            src: require('@/assets/images/apps/smartscreen2_512x512.png')
        },
        {
            name: 'jscreen',
            src: require('@/assets/images/apps/smartscreen3_512x512.png')
        },
        {
            name: 'telegram-desktop',
            src: require('@/assets/images/apps/tg_512x512.png')
        }
    ]
}
export default snap;